<div class="panel panel-main mt-3 mb-4">
    <div class="panel-heading pl-3 pt-3">
        <h3>{{ 'EMPLOYEES_TITLE' | translate }}</h3>
        <div class="panel-heading-keys">
            <span class="d-flex align-items-center" data-qa="qa-active-employees-label">
                |&nbsp;
                <span [innerHTML]="'ACTIVE_COUNT' | translate: { value: totalActiveEmployees }"></span>
            </span>
            <app-search placeholder="SEARCH" (search)="searchTextChange($event)"></app-search>
        </div>
    </div>
    <div class="panel-body pl-3 pb-4">
        <app-table
            class="employees-table"
            [loadingItems]="loading"
            [loadingTable]="taskAssigningIndicator.assigning || updating"
            [loadingTableText]="taskAssigningIndicator.text"
            [disableHover]="tableHoverEffectDisabled"
            [rowSelection]="true"
            [keyboardNavigation]="true"
            data-qa="qa-employee-list-table"
        >
            <ng-container header>
                <th class="flex-3" appTitleProvider appHeaderSort="employeeName">
                    {{ 'NAME' | translate }}
                </th>
                @if (showRoster) {
                    <th
                        class="flex-2"
                        appTitleProvider
                        appHeaderSort="rosterDepartmentName">
                        <span>{{ 'ROSTER_NAME' | translate }}</span>
                    </th>
                }
                <th class="flex-3" appTitleProvider appHeaderSort="skillLevelDescription">
                    <span>{{ 'COMPETENCE' | translate }}</span>
                </th>
                <th class="flex-3" appTitleProvider appHeaderSort="transport">
                    <span>{{ 'TRANSPORT' | translate }}</span>
                </th>
                <th class="flex-3" appTitleProvider appHeaderSort="fromTime,toTime">
                    <span>{{ 'SHIFT_TIME' | translate }}</span>
                </th>
                <th class="justify-content-center" appTitleProvider
                    [ngClass]="{'flex-2': breakpointValue >= BreakpointValue.LARGE,
                    'flex-1': breakpointValue < BreakpointValue.LARGE}"
                    appHeaderSort="isActive">
                    @if (breakpointValue >= BreakpointValue.LARGE) {
                        <span>{{ 'ACTIVE' | translate }}</span>
                    }
                    <app-checkbox
                        class="ml-1"
                        id="activeTask"
                        [(ngModel)]="selectAll"
                        (change)="toggleActiveSelectionAll()"
                    ></app-checkbox>
                </th>
                @if (isRideSharingEnabledOnClient) {
                    <th
                        [ngClass]="{'flex-3': breakpointValue >= BreakpointValue.LARGE,
                                'flex-1': breakpointValue < BreakpointValue.LARGE}"
                        class="justify-content-center" appHeaderSort="rideSharing"
                        appTitleProvider>
                        @if (breakpointValue >= BreakpointValue.LARGE) {
                            <span
                                class="mr-1">{{ 'RIDE_SHARING' | translate }}</span>
                        }
                        <app-checkbox
                            id="rideSharing"
                            [(ngModel)]="selectRideSharingAll"
                            (change)="toggleRideShareSelectionAll()"
                            [disable]="!checkIfSomeAreActive()"
                        ></app-checkbox>
                    </th>
                }
                @if ((isCriticalRosterFeatureEnabled | async) && showEmployeeStatusCol) {
                    <th class="icon-column"
                        appTitleProvider appHeaderSort="hasError"></th>
                }
            </ng-container>
            <ng-container body>
                @for (employee of employees; track employee) {
                    <tr
                        [ngClass]="{
                            active: employee.selected
                        }"
                        cdkDropList
                        [cdkDropListData]="employee.allocatedTasks"
                        (cdkDropListDropped)="droppedTask($event, employee, employees)"
                        (cdkDropListEntered)="taskEntered($event, employee)"
                        (click)="selectEmployee(employee)"
                    >
                        <td class="flex-3" appTitleProvider>
                            <span>{{ employee.employeeName }}</span>
                        </td>
                        @if (showRoster) {
                            <td class="flex-2" appTitleProvider>
                                <span> {{ employee.rosterDepartmentName }}</span>
                            </td>
                        }
                        <td class="flex-3" appTitleProvider>
                            <span>{{ employee.skillLevelDescription }}</span>
                        </td>
                        <td class="flex-3" appTitleProvider>
                            <span>{{ employee.transport.toUpperCase() | translate }}</span>
                        </td>
                        <td class="flex-3" appTitleProvider>
                            <span>
                                {{ employee | fromto }}
                                @if (employee.shiftCode) {
                                    <span>({{ employee.shiftCode }})</span>
                                }
                            </span>
                        </td>
                        <td [ngClass]="{'flex-2': breakpointValue >= BreakpointValue.LARGE,
                                        'flex-1': breakpointValue < BreakpointValue.LARGE}"
                            class="justify-content-center">
                            <app-checkbox
                                [id]="employee.employeeId + '-' + employee.workHourId"
                                [ngModel]="employee.isActive"
                                (change)="toggleActiveSelection(employee, $event)"
                            ></app-checkbox>
                        </td>
                        @if (isRideSharingEnabledOnClient) {
                            <td
                                [ngClass]="{'flex-3': breakpointValue >= BreakpointValue.LARGE,
                                        'flex-1': breakpointValue < BreakpointValue.LARGE}"
                                class="justify-content-center">
                                @if (isUsingBicycle(employee) != true) {
                                    <app-checkbox
                                        [id]="employee.employeeId + '-' + employee.rideSharing + '-list'"
                                        [ngModel]="employee.rideSharing"
                                        (change)="toggleRideShareSelection(employee, $event)"
                                        [disable]="!employee.isActive"
                                    ></app-checkbox>
                                }
                            </td>
                        }
                        @if ((isCriticalRosterFeatureEnabled | async) && showEmployeeStatusCol) {
                            <td class="icon-column my-auto"
                            >
                                @if (showRoster && !employee.rosterDepartmentName) {
                                    <app-tooltip
                                        appCustomPopover
                                        popoverText="EMPLOYEE_LIST_ROSTER_ERROR"
                                        placement="top"
                                        popoverType="error"
                                    >
                                        <ng-container icon>
                                            <span
                                                class="vismaicon vismaicon-sm vismaicon-filled vismaicon-error"></span>
                                        </ng-container>
                                    </app-tooltip>
                                }
                            </td>
                        }
                    </tr>
                }
            </ng-container>
        </app-table>
    </div>
</div>
